

import React, { useState, useEffect } from 'react';
import PersonIcon from '@mui/icons-material/Person';
import { APIURL } from '../../../configApi/apiConfig';
import axios from "../../../configApi/axiosConfig";

export default function ClienteInfoCard({ clientInfo, formatDate, navigate, permiso, compact = false }) {
  const [firma, setFirma] = useState("");

  

  const fetchFirma = async () => {
    try {
      const response = await axios.get(APIURL.get_firma_digital_cogno(clientInfo.cedula));
      if (response.data && response.data.data) {
        setFirma(response.data.data.FIRMA || "");

      } else {
        setFirma("");

      }
    } catch (error) {
      console.error('Error al cargar firma digital del cliente:', error);
      setFirma("");
    }
  };

  useEffect(() => {
    if (clientInfo && clientInfo.cedula) {
      fetchFirma();
    }
    // eslint-disable-next-line
  }, [clientInfo.cedula]);

  return (
    <div className="max-w-5xl mx-auto w-full">
      <div className="bg-white rounded-[2rem] shadow-[0_8px_30px_rgba(59,130,246,0.25)] border-2 border-blue-200 p-6 md:p-8 relative overflow-hidden">
        {/* Subtle decorative background blob */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-blue-50 rounded-full mix-blend-multiply filter blur-3xl opacity-60 -mr-20 -mt-20 pointer-events-none"></div>

        <div className={`flex flex-col ${compact ? '' : 'lg:flex-row'} gap-8 relative z-10`}>
          
          {/* IZQUIERDA: FOTO + FIRMA (Premium Presentation) */}
          <div className={`w-full ${compact ? '' : 'lg:w-1/3'} flex flex-col items-center gap-6 bg-white border border-blue-100 rounded-3xl p-6 shadow-[0_4px_20px_rgba(59,130,246,0.15)] hover:shadow-[0_8px_25px_rgba(59,130,246,0.2)] transition-all duration-300`}>
            
            {/* FOTO */}
            <div className="relative">
              {clientInfo.foto.length < 30 ? (
                <div className="w-48 h-48 flex items-center justify-center bg-slate-100 border-4 border-white rounded-full shadow-[0_4px_15px_rgba(59,130,246,0.15)]">
                  <PersonIcon style={{ fontSize: 80, color: '#cbd5e1' }} />
                </div>
              ) : (
                <img
                  src={clientInfo.foto}
                  alt="Foto del cliente"
                  className="w-48 h-48 object-cover rounded-full border-4 border-white shadow-[0_4px_15px_rgba(59,130,246,0.15)]"
                />
              )}
              {/* Status Dot */}
              <div className="absolute bottom-3 right-5 w-5 h-5 bg-emerald-500 border-4 border-white rounded-full shadow-sm"></div>
            </div>

            {/* FIRMA */}
            {permiso && (
              <div className="w-full text-center relative mt-4">
                <div className="absolute left-1/2 -translate-x-1/2 -top-3 z-10">
                  <span className="bg-blue-100 text-blue-800 text-[10px] font-bold px-4 py-1 rounded-full border border-blue-200 shadow-sm tracking-wider uppercase whitespace-nowrap">
                    Firma Autorizada
                  </span>
                </div>
                <div className="bg-white border-2 border-dashed border-blue-300 rounded-2xl px-4 py-6 shadow-[0_4px_10px_rgba(59,130,246,0.1)] hover:border-blue-500 hover:shadow-[0_6px_15px_rgba(59,130,246,0.15)] transition-all duration-300">
                  {firma ? (
                     <img
                       src={`data:image/png;base64,${firma}`}
                       alt="Firma"
                       className="h-20 mx-auto object-contain opacity-90 mix-blend-multiply"
                     />
                  ) : (
                    <img
                      src={require("../../../assets/img/Credito.png")}
                      alt="Firma"
                      className="h-10 mx-auto object-contain opacity-50 grayscale"
                    />
                  )}
                </div>
              </div>
            )}
          </div>

          {/* DERECHA: INFO (Dashboard Style) */}
          <div className="flex-1 flex flex-col">
            
            {/* HEADER */}
            <div className="mb-8 border-b border-slate-100 pb-4">
              <h2 className="text-2xl md:text-3xl font-bold text-[#2d3689] tracking-tight">
                {clientInfo.nombre || "Información del Cliente"}
              </h2>
              <p className="text-sm font-medium text-slate-500 mt-1 flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-blue-400 shadow-[0_0_8px_rgba(96,165,250,0.8)]"></span>
                Detalles principales de la solicitud
              </p>
            </div>

            {/* DATOS GRID */}
            <div className={`grid grid-cols-1 ${compact ? '' : 'sm:grid-cols-2'} gap-4 flex-1`}>
              {[
                ["Número Solicitud", clientInfo.NumeroSolicitud, "bg-white"],
                ["Cédula", clientInfo.cedula, "bg-white"],
                ["Fecha", formatDate(clientInfo.fecha), "bg-white"],
                ["Vendedor", clientInfo.vendedor, "bg-white"],
                ["Tipo de consulta", clientInfo.consulta, "bg-white"],
                ["Almacén", clientInfo.almacen, "bg-white"],
              ].map(([label, value, bgClass], idx) => (
                <div 
                  key={idx} 
                  className={`flex flex-col p-4 rounded-2xl border border-blue-100 shadow-[0_4px_12px_rgba(59,130,246,0.1)] hover:shadow-[0_6px_16px_rgba(59,130,246,0.2)] hover:-translate-y-0.5 transition-all duration-300 ${bgClass}`}
                >
                  <span className="text-[11px] font-bold uppercase tracking-wider text-slate-400 mb-1">
                    {label}
                  </span>
                  <span className="text-sm md:text-base font-semibold text-slate-800 break-words">
                    {value || "No especificado"}
                  </span>
                </div>
              ))}
            </div>

            {/* BOTÓN */}
            {!compact && (
              <div className="flex justify-end mt-8 pt-4 border-t border-slate-50">
                <button
                  name="aprobTodo"
                  className="group flex items-center gap-2 bg-[#2d3689] text-white px-8 py-3 rounded-full shadow-lg shadow-blue-900/20 hover:bg-blue-800 hover:shadow-xl hover:shadow-blue-900/30 hover:-translate-y-0.5 transition-all duration-300 font-semibold text-sm"
                  onClick={() => navigate("/ListadoSolicitud", { replace: true })}
                >
                  Volver al Listado
                  <span className="transform group-hover:translate-x-1 transition-transform">→</span>
                </button>
              </div>
            )}

          </div>
        </div>
      </div>
    </div>
  );
}
